<template>
  <div>
    <common-news :categoryList="categoryList" title="房县黄酒协会 | 会员入口"></common-news>
  </div>
</template>
<script>
import commonNews from "@/components/common-news.vue";
export default {
  components: { commonNews },
  data() {
    return {
      categoryList: [
        {
          name: "房县黄酒协会简介",
          icon: "el-icon-s-custom",
          isActive:false,
          children: [
            { channelId: 184, title: "领导风采" },
            {
              channelId: 182,
              title: "机构设置",
            },
            { channelId: 183, title: "协会章程" },
          ],
        },
        {
          name: "工作动态",
          icon: "el-icon-s-order",
          isActive:false,
          children: [
            {
              channelId: 185,
              title: "工作要闻",
            },
            { channelId: 168, title: "通知公告" },
          ],
        },
        {
          name: "信息公开",
          icon: "el-icon-s-comment",
          isActive:false,
          children: [
            {
              channelId: 179,
              title: "年度数据",
            },
            { channelId: 186, title: "会员查询" },
            { channelId: 181, title: "国标地标" },
            { channelId: 187, title: "企业黄页" },
          ],
        },
      ],
    };
  },
  methods: {},
  mounted() {},
};
</script>
